import axios from "axios";

export const savePostulation = (data, publicationId, callback) => {
  var promise = axios({
    method: "POST",
    url: `/api/publications/${publicationId}/minisite_postulations`,
    data: data,
    headers: {
      "X-CSRF-TOKEN": window.Hupe8.token
    }
  });
  promise
    .then(response => {
      callback(response);
    })
    .catch(err => {
      callback(err.response);
    });
};
